import {
  FETCH_PHOTOGRAPHERS_REQUEST,
  FETCH_PHOTOGRAPHERS_SUCCESS,
  FETCH_PHOTOGRAPHERS_FAILURE
} from '../actions';

const defaultPhotographersState = {
  photographers: [],
  loading: false,
  error: false
};

const reducer = (state = defaultPhotographersState, action) => {
  switch(action.type){
    case FETCH_PHOTOGRAPHERS_REQUEST:
      return {
        ...state,
        loading: true,
        photographersLoaded: false,
      };
    case FETCH_PHOTOGRAPHERS_SUCCESS:
      return {
        ...state,
        photographers: action.photographers,
        loading: false,
        photographersLoaded: true,
      };
    case FETCH_PHOTOGRAPHERS_FAILURE:
      return {
        ...state,
        loading: false,
        photographersLoaded: false,
        error: true
      };
    default:
      return state;
  }
}

export default reducer;
